export default [
    {
        path: '/',
        name: 'index',
        // redirect: '/home/index',
        component: () => import('@/views/HomeHeader/index.vue'),
        children: [
            {
                path: '/',
                name: 'index1',
                // meta: {
                // 	auth: [1],
                // },
                component: () => import('@/views/Home/index.vue'),
                children: [
                    {
                        name: 'home1',
                        path: '/',
                        meta: {
                            auth: [1],
                        },
                        component: () => import('@/views/Index/index.vue')
                    },
                ]
            }
        ]
    },
    {
        path: "/home",
        name: "",
        component: () => import('@/views/HomeHeader/index.vue'),
        redirect: '/home/index',
        children: [
            {
                path: '/home/index',
                name: 'index',
                // meta: {
                // 	auth: [1],
                // },
                component: () => import('@/views/Home/index.vue'),
                children: [
                    {
                        name: 'home',
                        path: '/home/index',
                        meta: {
                            auth: [1],
                        },
                        component: () => import('@/components/audit/index.vue')
                    },
                    {
                        name: 'discover',  // 发现
                        path: '/home/discover',
                        meta: {
                            auth: [1],
                        },
                        component: () => import('@/views/Discover/index.vue')
                    },
                    {
                        name: 'forward',  // 发现
                        path: '/home/forward',
                        meta: {
                            auth: [1],
                        },
                        component: () => import('@/views/Index/forward.vue')
                    },
                    // {
                    //     name: 'transaction',  // 交易行
                    //     path: '/home/transaction',
                    //     meta: {
                    //         auth: [1],
                    //     },
                    //     component: () => import('@/views/Transaction/index.vue')
                    // },
                    {
                        name: 'newServer',  // 资讯
                        path: '/home/newServer',
                        meta: {
                            auth: [1],
                        },
                        component: () => import('@/views/newServer/index.vue')
                    },
                    {
                        name: 'prefecture',  // 专区
                        path: '/home/prefecture',
                        meta: {
                            auth: [1],
                        },
                        component: () => import('@/views/Prefecture/index.vue')
                    },
                    {
                        name: 'list',  // 榜单
                        path: '/home/list',
                        meta: {
                            auth: [1],
                        },
                        component: () => import('@/views/List/index.vue')
                    },
                    {
                        name: 'task',  // 下载
                        path: '/home/task',
                        meta: {
                            auth: [1],
                        },
                        component: () => import('@/views/task/index.vue')
                    },
                    {
                        name: 'test',  // 测试用例
                        path: '/test',
                        meta: {
                            auth: [1],
                        },
                        component: () => import('@/views/Test/index.vue')
                    },
                    {
                        name: 'search',  // 搜索页
                        path: '/search',
                        meta: {
                            auth: [1],
                            showNav: true,
                        },
                        component: () => import('@/views/Home/search.vue')
                    },
                    {
                        name: 'user',  // 个人资料
                        path: '/user',
                        meta: {
                            auth: [1],
                            keepAlive: false,
                            showList: 0,
                            showNav: false,
                            menu: [{
                                path: "/home",
                                name: "当前所在位置"
                            }, {
                                path: "/user",
                                name: "个人中心"
                            }]
                        },
                        component: () => import('@/views/User/index.vue')
                    },
                    {
                        name: 'otherUser',  // 个人资料
                        path: '/otherUser',
                        meta: {
                            auth: [1],
                            showList: 0,
                            showNav: false,
                        },
                        component: () => import('@/views/OtherUser/index.vue')
                    },
                    {
                        name: 'modification',  // 资料编辑
                        path: '/user/modification',
                        meta: {
                            auth: [1],
                            keepAlive: false,
                            showList: 0,
                            showNav: false,
                            menu: [{
                                path: "/home",
                                name: "当前所在位置"
                            }, {
                                path: "/user",
                                name: "个人中心"
                            }, {
                                path: "/user/modification",
                                name: "编辑资料"
                            }]
                        },
                        component: () => import('@/views/User/Modification/index.vue')
                    },
                    {
                        name: 'wallet',  // 钱包
                        path: '/wallet',
                        meta: {
                            auth: [1],
                            keepAlive: false,
                            showList: 0,
                            showNav: false,
                            menu: [{
                                path: "/home",
                                name: "当前所在位置"
                            }, {
                                path: "/user",
                                name: "个人中心"
                            }, {
                                path: "/wallet",
                                name: "钱包"
                            }]
                        },
                        component: () => import('@/views/Wallet/index.vue')
                    },
                    {
                        name: 'boxTopUp',  // 盒子充值
                        path: '/wallet/boxTopUp',
                        meta: {
                            auth: [1],
                            keepAlive: false,
                            showList: 0,
                            showNav: false,
                            menu: [{
                                path: "/home",
                                name: "当前所在位置"
                            }, {
                                path: "/user",
                                name: "个人中心"
                            }, {
                                path: "/wallet",
                                name: "钱包"
                            }, {
                                path: "/wallet/boxTopUp",
                                name: "盒币充值"
                            }]
                        },
                        component: () => import('@/views/Wallet/BoxTopUp/index.vue')
                    },
                    {
                        name: 'pay',  // 充值
                        path: '/pay',
                        meta: {
                            auth: [1],
                        },
                        component: () => import('@/views/Pay/index.vue')
                    },
                    {
                        name: 'home',
                        path: '/myGame/gameDetail',
                        meta: {
                            auth: [1],
                        },
                        component: () => import('@/views/MyGame/GameDetail/index.vue')
                    },
                ]
            },
            {
                path: '/news',
                name: 'news',
                component: () => import('@/views/HomeHeader/news.vue'),
            },
            {
                path: '/996news',
                name: '996news',
                component: () => import('@/views/HomeHeader/news.vue'),
            },
            {
                path: '/newsDetail/:detailId',
                name: 'newsDetail',
                component: () => import('@/views/HomeHeader/newsDetail.vue'),
            },
            {
                path: '/downloads',
                name: 'downloads',
                component: () => import('@/views/HomeHeader/downloads.vue'),
            },
            {
                path: '/aboutUs',
                name: 'aboutUs',
                meta: {
                    auth: [1],
                },
                component: () => import('@/views/HomeHeader/Model/aboutUs.vue'),
            },
            {
                path: '/contactUs',
                name: 'contactUs',
                meta: {
                    auth: [1],
                },
                component: () => import('@/views/HomeHeader/Model/contactUs.vue'),
            },
            {
                path: '/softwareLis',
                name: 'softwareLis',
                meta: {
                    auth: [1],
                },
                component: () => import('@/views/HomeHeader/Model/softwareLis.vue'),
            },
            {
                path: '/privacy',
                name: 'privacy',
                meta: {
                    auth: [1],
                },
                component: () => import('@/views/HomeHeader/Model/privacy.vue'),
            },
            {
                path: '/permit',
                name: 'permit',
                meta: {
                    auth: [1],
                },
                component: () => import('@/views/HomeHeader/Model/permit.vue'),
            },
            {
                path: '/developersBackstage',
                name: 'developersBackstage',
                // component: () => import('@/views/HomeHeader/developersBackstage.vue'),
            },
            {
                path: '/teamwork',
                name: 'teamwork',
                // component: () => import('@/views/HomeHeader/teamwork.vue'),
            },
            {
                name: 'gameDetail',
                path: '/myGame/gameDetail/:comment/:uids/:type/:id',
                meta: {
                    auth: [1],
                },
                component: () => import('@/views/MyGame/GameDetail/index.vue')
            },
        ]
    },

    // {
    //     path: '/login',
    //     name: 'login',
    //     component: () => import(/* webpackChunkName: "login" */ '@/views/Login/index.vue'),
    // },
    {
        path: '/logout',
        name: 'logout',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/Logout.vue'),
    },
]
